<template>
  <section class="layout-others">
    <div class="nav-tabs">
      <div
        v-for="item of data"
        :key="item.id"
        class="item"
        :class="{ 'is-active': currentActiveId === item.id }"
        @click="handleItemClick(item.id)"
      >
        <svg-icon :icon-class="`product-icon-${item.name_zh_CN}`" />
        <span style="white-space: nowrap;">{{ item.name }}</span>
      </div>
    </div>
    <div class="content-panes" :style="{ height: isEn && currentActiveId === 209847 ? '150px' : undefined }">
      <div
        v-for="group of data"
        :key="group.id"
        class="group"
        :class="{ 'is-active': currentActiveId === group.id }"
        :inert="currentActiveId !== group.id"
      >
        <div
          v-for="item of group.data || []"
          :key="item.productId"
          class="item"
        >
          <div class="name">{{ item.productName }}</div>
          <div v-if="item.memo" class="desc">{{ item.memo }}</div>
          <action-buttons :product-name="item.productName_zh_CN" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import lang from '@/lang';
import ActionButtons from "./action-buttons.vue";
import { commons } from "./mixin";
export default {
  name: "LayoutOthers",
  components: {
    ActionButtons
  },
  mixins: [commons],
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      isEn: lang.locale === 'en',
      currentActiveId: null
    };
  },
  watch: {
    data: {
      handler(val) {
        this.currentActiveId = val?.[0].id ?? null;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleItemClick(id) {
      this.currentActiveId = id;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/common";
.layout-others {
  display: flex;
  flex-direction: column;
  .nav-tabs {
    display: flex;
    justify-content: space-between;
    gap: 50px;
    height: 56px;
    .item {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      gap: 8px;
      width: 200px;
      padding: 0 24px;
      background-color: #edeff2;
      border-radius: 8px;
      color: #6e758a;
      font-size: 16px;
      line-height: 24px;
      position: relative;
      user-select: none;
      transition: background-color 0.3s, color 0.3s, border-radius 0.3s;
      &:hover {
        background-color: #e7ecfa;
      }
      &.is-active {
        color: $color-blue;
        background-color: #e7ecfa;
        border-radius: 8px 8px 0 0;
        &::before,
        &::after {
          opacity: 1;
        }
      }
      &::before {
        content: "";
        width: 100%;
        height: 2px;
        background: $color-blue;
        opacity: 0;
        position: absolute;
        bottom: 0;
        pointer-events: none;
        transition: opacity 0.3s;
      }
      &::after {
        content: "";
        width: 0;
        height: 0;
        border-left: 5px solid rgba(0, 0, 0, 0);
        border-right: 5px solid rgba(0, 0, 0, 0);
        border-top: 5px solid $color-blue;
        opacity: 0;
        position: absolute;
        left: 50%;
        bottom: -4px;
        pointer-events: none;
        transform: translateX(-50%);
        transition: opacity 0.3s;
      }
      svg {
        min-width: 24px;
        width: 24px;
        height: 24px;
      }
    }
  }
  .content-panes {
    height: 128px;
    margin-top: 48px;
    position: relative;
    .group {
      display: flex;
      gap: 48px;
      opacity: 0;
      position: absolute;
      inset: 0;
      pointer-events: none;
      transition: opacity 0.3s;
      &.is-active {
        pointer-events: auto;
        opacity: 1;
      }
      .item {
        width: 260px;
        .name {
          margin-bottom: 8px;
          color: $color-text-primary;
          font-size: 16px;
          font-weight: bold;
        }
        .desc {
          margin-bottom: 16px;
          color: $color-text-regular;
          font-size: 14px;
          line-height: 22px;
          // text-align: justify;
        }
      }
    }
  }
}
</style>
